const innovationAreas = [
  { title: "Innovation Projects", icon: "ri-lightbulb-flash-line" },
  { title: "Innovation Circles", icon: "ri-team-line" },
  { title: "Practical Innovation", icon: "ri-tools-line" },
  { title: "Factory Transformation", icon: "ri-building-4-line" },
  { title: "Innovation Capability", icon: "ri-brain-line" },
  { title: "Industry Collaboration", icon: "ri-share-forward-line" },
];

export default function Innovation() {
  return (
    <section
      id="innovation"
      className="w-full bg-background-50 py-10 md:py-12 lg:py-14"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-8 md:mb-10">
          <p className="text-xs font-semibold tracking-widest uppercase text-accent-600 mb-4">
            Innovation Ecosystem
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            From Knowledge to Practical Innovation
          </h2>
        </div>

        {/* TTIH Introduction */}
        <div className="max-w-4xl mx-auto text-center mb-8 md:mb-10">
          <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mb-4">
            Textile Today Innovation Hub (TTIH)
          </h3>
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
            A&amp;J&apos;s innovation-focused platform works to foster practical
            innovation, capability development and transformation across the
            textile and apparel industry. TTIH collaborates with external
            platforms and organizations on specific initiatives to drive
            meaningful change.
          </p>
        </div>

        {/* Areas Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {innovationAreas.map((area) => (
            <div
              key={area.title}
              className="flex items-start gap-4 bg-background-100 border border-background-200/70 rounded-lg p-6 hover:border-accent-300/60 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 shrink-0">
                <i className={`${area.icon} text-lg`} />
              </div>
              <div>
                <h4 className="text-base font-heading font-semibold text-foreground-950">
                  {area.title}
                </h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}